export default function textLengthValidation(fieldValue, fieldLength, fieldName) {
    if (fieldValue?.length > fieldLength) {
      return `${fieldName} is too long. Maximum ${fieldLength} characters.`
    }
    return ''
  }